export default "__VITE_ASSET__aae969cb__"